module.exports = __webpack_public_path__ + "img/default.cdd975e1.png";